import { UIText1 } from '@cian/ui-kit';

import * as styles from './Area.css';

export interface IAreaProps {
  texts: (string | null)[];
}

export function Area({ texts }: IAreaProps) {
  if (!texts) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {texts.map((text, index) => {
        if (text && index === 0) {
          return <UIText1 key={index}>{text}</UIText1>;
        }
        if (text) {
          return (
            <UIText1 key={index} color="text-secondary-default">
              {text}
            </UIText1>
          );
        }

        return null;
      })}
    </div>
  );
}
